// extracted by mini-css-extract-plugin
export default {"control":"_3g2shqJdWnUUF6-uxoaRA-"};